module.exports = __webpack_public_path__ + "static/media/banner-clients-04.a71792f7.jpg";